import App from '@containers/Resources/ProductDocumentation/App';
import {createBrowserRouter, Navigate, RouterProvider, useLocation, useParams} from 'react-router-dom';
import ProductDocumentationList from '@containers/Resources/ProductDocumentation/ProductDocumentationList';
import ProductDocumentationDetailQuery from '@containers/Resources/ProductDocumentation/ProductDocumentationDetail';

export const productDocumentationRoutes = [
    {
        path: '/resources/product-documentation/*',
        exact: true,
        element: <App/>,
        children: [
            {
                path: '',
                element: <ProductDocumentationList/>
            },
            {
                path: ':sku',
                element: <ProductDocumentationDetailQuery/>
            },
            {
                path: '*',
                element: <Navigate to="/resources/product-documentation"/>
            }
        ]
    }
];


